// CategorySkeleton.tsx
import React from "react";

const CategorySkeleton = () => {
  return (
    <div className="w-full overflow-x-auto whitespace-nowrap mb-4 mt-1 bg-white z-5 flex items-center md:py-2">
      <div className="flex space-x-4 px-2">
        {[...Array(4)].map((_, i) => (
          <div
            key={i}
            className="h-8 w-20 bg-gray-200 rounded-md animate-pulse"
          />
        ))}
      </div>
    </div>
  );
};

export default CategorySkeleton;
